import C from '../constants/serviceCatalog';
import { axiosInstance } from '../utils/helpers';
import { setFetchingCount } from './app';

export function getFunctionalitiesMetaDataArray(parentID, isRemove) {
  return (dispatch) => {
    dispatch(setFetchingCount(true));
    let url = '/api/v1/ssp/toolbox/getToolboxItems?id=' + parentID;
    return axiosInstance
      .get(url)
      .then((response) => {
        let result = [
          {
            type: 'FOLDER',
            id: 1,
            name: 'Home',
            description: 'Home description',
            children: response.data.serviceCatalogItems
          }
        ];
        dispatch({
          type: C.SET_CATALOG_ITEMS,
          payload: result,
          isRemove: isRemove,
          branch: result[0]
        });
      })
      .finally(() => {
        dispatch(setFetchingCount(false));
      });
  };
}

export function getToolboxItemsByParentID(branch, isRemove) {
  return (dispatch) => {
    dispatch(setFetchingCount(true));
    const url = '/api/v1/ssp/toolbox/getToolboxItems?id=' + branch.id;
    axiosInstance
      .get(url)
      .then((response) => {
        let currentBranches = response.data.serviceCatalogPaths;
        let result = [
          {
            type: 'FOLDER',
            id: 1,
            name: 'Home',
            description: 'Home description',
            children: response.data.serviceCatalogItems
          }
        ];
        const newBranch = [result[0]].concat(currentBranches);
        dispatch({
          type: C.SET_CATALOG_ITEMS_WITH_BRANCH,
          payload: result,
          isRemove: isRemove,
          branch: newBranch
        });
      })
      .finally(() => {
        dispatch(setFetchingCount(false));
      });
  };
}

export function getToolboxItemsByID(id) {
  return (dispatch) => {
    dispatch(setFetchingCount(true));
    const url = '/api/v1/ssp/toolbox/' + id;
    axiosInstance
      .get(url)
      .then((response) => {
        dispatch({
          type: C.SET_SYSAI_CHATBOT_CALALOG_ITEM,
          payload: response.data
        });
      })
      .finally(() => {
        dispatch(setFetchingCount(false));
      });
  };
}

export function getToolboxItemsByRef(targetRef) {
  return (dispatch) => {
    dispatch(setFetchingCount(true));
    const url = '/api/v1/ssp/toolbox/getToolboxItemReference?id=' + targetRef;
    axiosInstance
      .get(url)
      .then((response) => {
        const serviceCatalogItems =
          response.data.serviceCatalogItems[0].children;
        let currentBranches = response.data.serviceCatalogPaths;
        let result = [
          {
            type: 'FOLDER',
            id: 1,
            name: 'Home',
            description: 'Home description',
            children: serviceCatalogItems
          }
        ];

        let firstItem = [
          {
            type: 'FOLDER',
            id: 1,
            name: 'Home',
            description: 'Home description'
          }
        ];

        const newBranch = [firstItem[0]].concat(currentBranches);

        dispatch({
          type: C.SET_CATALOG_ITEMS_WITH_BRANCH,
          payload: result,
          branch: newBranch
        });
      })
      .finally(() => {
        dispatch(setFetchingCount(false));
      });
  };
}

export function addBranchToCurrentBranches(branch) {
  return (dispatch) => {
    dispatch(setFetchingCount(true));
    dispatch({ type: C.ADD_BRANCH_TO_CURRENT_BRANCHES, branch: branch });
    dispatch(setFetchingCount(false));
  };
}

export function removeBranchFromCurrentBranches(branch) {
  return (dispatch) => {
    dispatch(setFetchingCount(true));
    dispatch({ type: C.REMOVE_BRANCH_FROM_CURRENT_BRANCHES, branch: branch });
    dispatch(setFetchingCount(false));
  };
}


// WEBPACK FOOTER //
// ./actions/serviceCatalog.js